import Select from "react-select";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../../../components/layouts/Card";
import { Option } from "../../../../interfaces/Options";
import { RootState } from "../../../../redux/rootReducers";
import { InputWrapper, SelectStyle } from "../../../../components/forms/FormComponents";
import { setBooking, setError } from "../../../../redux/reducers/bookings/actions";
import { clearError, fieldErrorMessage, fieldHasErrors } from "../../../../helpers/errorHandler";

const BookingCreateIssuer = () => {

  const dispatch = useDispatch();
  const [roleOptions, setRoleOptions] = useState<Option[]>([]);
  const errors = useSelector((state: RootState) => state.booking.error);
  const roleItems = useSelector((state: RootState) => state.role.roles);
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  const booking = useSelector((state: RootState) => state.booking.updatedBooking);
  const [issuerRoleSelected, setIssuerRoleSelected] = useState<Option | null>(null);

  useEffect(() => {
    const newOptions: Option[] = [];
    roleItems.forEach(item => {
      if (item.id) {
        newOptions.push({
          value: item.id?.toString(),
          label: item.role_name
        });
      }
    });
    setRoleOptions(newOptions);
  }, [roleItems])

  const onChangeIssuerName = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    clearError('issuer_name', errors, setError, dispatch);
    dispatch(setBooking({
      ...booking,
      issuer_name: e.target.value
    }));
  };

  const onChangeIssuerPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    clearError('issuer_phone', errors, setError, dispatch);
    dispatch(setBooking({
      ...booking,
      issuer_phone: e.target.value
    }));
  };

  const onChangeIssuerRole = (e: Option | null) => {
    if (!booking || !e) return;
    clearError('id_role', errors, setError, dispatch);
    setIssuerRoleSelected(e);
    const idRole = parseInt(e.value);
    dispatch(setBooking({
      ...booking,
      id_role: idRole
    }));
  };

  if (!booking) {
    return <div />
  }

  return (
    <Card>
      <div className="card--title">
        <h2 className="card--title-title">Data Peminjam</h2>
        <p className="card--title-description">Data yang akan menggunakan ruangan</p>
      </div>
      <div className="card--body">
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('issuer_name', errors)}>
          <div className="input--field">
            <label>Nama Peminjam</label>
            <input
              type="text"
              disabled={isLoading}
              value={booking.issuer_name}
              onChange={onChangeIssuerName}
              placeholder="Masukkan nama peminjam disini"
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('issuer_name', errors) }
          </div>
        </InputWrapper>
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('issuer_phone', errors)}>
          <div className="input--field">
            <label>Nomor Telepon Peminjam</label>
            <input
              type="text"
              disabled={isLoading}
              value={booking.issuer_phone}
              onChange={onChangeIssuerPhone}
              placeholder="Masukkan nomor telepon peminjam"
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('issuer_phone', errors) }
          </div>
        </InputWrapper>
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('id_role', errors)}>
          <div className="input--field select">
            <label>Divisi Peminjam</label>
            <Select
              styles={SelectStyle}
              isDisabled={isLoading}
              value={issuerRoleSelected}
              options={roleOptions}
              onChange={(e: any) => onChangeIssuerRole(e)}
              menuPlacement="top"
              menuPortalTarget={document.querySelector("body")}
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('id_role', errors) }
          </div>
        </InputWrapper>
      </div>
    </Card>
  );
}

export default BookingCreateIssuer;